// extracted by mini-css-extract-plugin
export var compactFilters = "_h0-4";
export var detailImage = "_h0-1";
export var dropdownContainer = "_h0-2";
export var imageContainer = "_h0-0";
export var selectedCard = "_h0-3";